<template>
  <div class="gamePageWrap">
    <div v-if="url" class="gameFrameBox">
      <iframe class="gameFrame" ref="iframe" scrolling="auto" frameborder="0" id="iframe"></iframe>
    </div>
    <!-- 左上角悬浮返回键：iframe 模式下唯一可靠的“回首页”出口，浮在游戏之上、不占布局、不压画面。
         即使落到厂商“已安全退出”中转页，它仍在最上层可点。 -->
    <div class="gameBackBtn" @click="goBack">
      <svg viewBox="0 0 24 24" width="20" height="20" aria-hidden="true">
        <path d="M15 4 L7 12 L15 20" fill="none" stroke="#fff" stroke-width="2.6" stroke-linecap="round" stroke-linejoin="round" />
      </svg>
    </div>
  </div>
</template>
<script>
export default {
  name: 'gamePage',
  data() {
    return {
      url: null,
    };
  },
  created() {
    let that = this;
    var query = that.$route.query;
    // 打开代理
    console.log(query)
    if (query.dailiD == 1) {
      that.getAgentLoginUrl();
      return;
    }
    // 打开客服
    if (query.dailiD == 2) {
      that.getservicerurl();
      return;
    }
    if (query.app == 1) {
     that.url = that.$store.state.appInfo.ios_download_url;
      return;
    }
    if (query.name) {
      that.goGamePage(query.name, query.type, query.code);
    }
  },
  methods: {
    // 返回：iframe 内游戏会往顶层 history 塞很多条记录，$router.back() 只会在 iframe 里回退、
    // 永远退不出本页。改为直接 replace 回进入游戏前记录的来源页（无则回首页）。
    goBack() {
      var p = sessionStorage.getItem('gameBackPath') || '/';
      if (!p || p.indexOf('/gamePage') === 0) p = '/';
      this.$router.replace(p);
    },
    // 打开客服
    getservicerurl() {
      let that = this;
      that.$apiFun.post('/api/getservicerurl', {}).then(res => {
        if (res.code != 200) {
          that.showTost(0, res.message);
        }
        if (res.code == 200) {
          that.url = res.data.url;
        }
      });
    },
    // 打开代理
    getAgentLoginUrl() {
      let that = this;
      that.$apiFun.get('/api/getAgentLoginUrl', {}).then(res => {
        if (res.code != 200) {
          that.showTost(0, res.message);
        }
        if (res.code == 200) {
          that.url = res.data.url;
        }
      });
    },
    // 打开游戏
    goGamePage(name, type, code) {
      let that = this;

      that.$apiFun
        .post('/api/getGameUrl', { plat_name: name, game_type: type || 0, game_code: code, is_mobile_url: 1 })
        .then(res => {
          console.log(res);
          if (res.code != 200) {
            that.$parent.showTost(0, res.message);
          }
          if (res.code == 200) {
            that.url = res.data.url;
          }
        })
        .catch(res => {});
    },
  },
  updated() {
    let that = this;
    if (that.$refs.iframe && that.url) {
      that.$refs.iframe.contentWindow.location.replace(that.url);
    }
  },
};
</script>

<style lang="scss" scoped>
.gamePageWrap {
  background: #000;
}
// 静态全屏：pin 左上角 + width100% + height 用 dvh（随 iOS/安卓工具栏显隐自动贴合可见区）。
// 不用 bottom:0（那会参照大视口，iOS 又被工具栏遮）；不用任何 JS 尺寸监听（消除反馈循环=不抖）。
.gameFrameBox {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100vh; // 老浏览器回退
  height: 100dvh; // 现代浏览器：动态视口，底部控制条不再被工具栏遮
  overflow: hidden;
  background: #000;
  z-index: 1;
}
.gameFrame {
  display: block;
  width: 100%;
  height: 100%;
  border: 0;
}
// 左上角半透明小悬浮返回键
.gameBackBtn {
  position: fixed;
  top: calc(8px + env(safe-area-inset-top, 0px));
  left: 8px;
  z-index: 9999;
  width: 36px;
  height: 36px;
  border-radius: 50%;
  background: rgba(0, 0, 0, 0.45);
  display: flex;
  align-items: center;
  justify-content: center;
  -webkit-tap-highlight-color: transparent;
  box-shadow: 0 1px 4px rgba(0, 0, 0, 0.3);
}
.gameBackBtn:active {
  background: rgba(0, 0, 0, 0.65);
}
</style>



// WEBPACK FOOTER //
// src/components/mode/gamePage.vue